import { render, staticRenderFns } from "./BtnCommencer.vue?vue&type=template&id=03943745&lang=html&"
import script from "./BtnCommencer.vue?vue&type=script&lang=js&"
export * from "./BtnCommencer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports